import React from 'react';
import { useSelector } from 'react-redux';
import styled, { withTheme } from 'styled-components';
import constants from 'constants/index';

const light = constants.THEME.LIGHT;

const FreeSVG = styled('svg')`
  color: ${props => {
    const lightTheme = props.$selectedTheme === light;
    return props.color || getColor(props, lightTheme ? 'onPrimary' : 'darkGrey');
  }};
  font-family: Poppins-Bold, Poppins;
  font-size: 220px;
  font-weight: 700;
`;

const FreeText = withTheme(props => {
  const { width, height, theme, color } = props;
  const userDataStore = useSelector(state => state.userData);
  const selectedTheme = userDataStore.userPreferences.theme;

  return (
      <FreeSVG
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 501.81 320.87"
        version="1.1"
        theme={theme}
        $selectedTheme={selectedTheme}
        aria-hidden='true'
        role='img'
        width={width || 24}
        height={height || 24}
        preserveAspectRatio='xMidYMid meet'
        color={color}
      >
        <text fill='currentColor' transform="translate(0 187.55)"><tspan x="0" y="0">FREE</tspan></text>
      </FreeSVG>
  );
});

export { FreeText };


